/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import useHorizontalDrag from '../../../hooks/useHorizontalDrag';

import styles from './HorizontalScrollList.module.scss';

const noop = () => {};

const HorizontalScrollList = ({
  items,
  scrollToSection = noop,
  activeItem = 0, // Index of the active item
  renderItem,
  listClassName = null,
  listItemClassName = null
}) => {
  const {
    containerRef,
    isDragging,
    handleMouseDown,
    handleMouseUp,
    handleTouchStart,
    handleTouchEnd,
    navigateToItem
  } = useHorizontalDrag({
    onMoveStart: () => {},
    onMove: () => {}
  });

  useEffect(() => {
    if (activeItem) {
      navigateToItem(activeItem);
    }
  }, [activeItem]);

  const handleItemClick = caption => {
    if (isDragging()) {
      return;
    }

    scrollToSection(caption);
  };

  const handleClickCapture = e => {
    if (isDragging()) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  return (
    <ul
      className={classNames(styles['horizontal-scroll-list'], listClassName)}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onDragStart={e => e.preventDefault()}
      onClickCapture={handleClickCapture}
      ref={containerRef}
    >
      {items.map((item, position) => (
        <li
          key={item.id}
          className={classNames(
            styles['horizontal-scroll-list__item'],
            listItemClassName
          )}
        >
          {renderItem(item, handleItemClick, position)}
        </li>
      ))}
    </ul>
  );
};

HorizontalScrollList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  scrollToSection: PropTypes.func,
  activeItem: PropTypes.number,
  renderItem: PropTypes.func.isRequired,
  listClassName: PropTypes.string,
  listItemClassName: PropTypes.string
};

export default HorizontalScrollList;
